export const state = () => ({
  tableQrList: []
});
